import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable, take } from "rxjs";
export interface SearchHistoryItem {
    name: string;
    type: 'order' | 'product' | 'account';
    data: any;
}
export const HISTORY_STORAGE_KEY = "yss-search-history";

@Injectable({
    providedIn: "root",
})
export class SearchHistoryService {
    _history$ = new BehaviorSubject<Array<SearchHistoryItem>>([]);
    history$ = this._history$.asObservable();
    hasHistory$ = this.history$.pipe(map(items => !!items.length))
    constructor() {}

    getHistory(): Observable<SearchHistoryItem[]> {
        return this.history$;
    }
  
    setHistory(history: SearchHistoryItem[]): void {
        this._history$.next(history);
        this.saveHistory(history)
    }
    addHistoryItem(item: SearchHistoryItem): void {
        this.history$.pipe(take(1)).subscribe((items) => {
            items.push(item);
            this.setHistory(items);
        });
    }
    clearHistory(): void {
        this._history$.next([]);
        this.saveHistory([]);
    }
    removeHistoryItem(index: number): void {
        this.history$.pipe(take(1)).subscribe((items) => {
            items.splice(index, 1);
            this.setHistory(items);
        });
    }
    saveHistory(items: SearchHistoryItem[]): void {
        localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(items));
    }
    loadHistory(): void {
        let history = [];
        try {
            history = JSON.parse(localStorage.getItem(HISTORY_STORAGE_KEY));
            if (!history) {
                history = [];
            }
        } catch (e) {
            // ...
        }
        this.setHistory(history);
    }
}
